import {useContext} from 'react';
import {UserContext} from '../Context/UserContext';

/**
 * Dérive les permissions du compte à partir de l'utilisateur courant
 * (renvoyé par /api/user, cf. UserContext) : un utilisateur ne peut gérer
 * l'entreprise que s'il appartient à un compte de type "company" et qu'il
 * en est administrateur.
 */
export const usePermissions = () => {
    const {userInfo, loading, refreshUserData} = useContext(UserContext);

    const currentUser = userInfo || null;
    const currentClient = userInfo?.client || null;
    const isCompanyUser = currentClient?.type_client === 'company';
    const isAdministrator = !!currentUser?.is_administrator_account;
    const isCompanyAdmin = isCompanyUser && isAdministrator;

    return {
        currentUser,
        currentClient,
        loading,
        error: null,
        refreshUserData,

        canEditOwnProfile: !!currentUser,
        canEditCompanyInfo: isCompanyAdmin,
        canManageUsers: isCompanyAdmin,
        isCompanyUser,
        isIndividualUser: !isCompanyUser,
        isAdministrator,
    };
};
